import React, { StrictMode, Suspense, useEffect, useLayoutEffect, useState, useContext, useRef } from 'react';
import { AppProvider } from "./context/AppContext.jsx";
import { ApiProvider } from "./context/ApiContext.jsx";
import { AuthWrapper } from "./context/AuthContext.jsx";
import { RoomProvider } from './context/RoomContext.jsx';
import { BrowserRouter, Route, Routes, useLocation, Outlet, } from 'react-router-dom';

import { showMain, hideMain, i18n } from './helpers/HelperFunctions.js';
//import Header from './components/Header.jsx';
import Footer from './components/Footer.jsx';
import Home from './pages/Home.jsx';
import Game from './pages/Game.jsx';
import Demo from './pages/Demo.jsx';
import QuickMatch from './pages/QuickMatch.jsx';

import DemoAuthProvider from './context/DemoAuthProvider.jsx';

function useScrollToTop() {
	const location = useLocation();
	useEffect(() => {
		window.scrollTo({ top: 0, left: 0, behavior: "instant" });
	}, [location.pathname, location.search]);
}

function PublicLayout() {
	useScrollToTop();
	return (
		<>
			<ApiProvider>
				<main>
					<Outlet />
				</main>
				<Footer />
			</ApiProvider>
		</>
	);
}
function FullLayout() {
	useScrollToTop();
	return (
		<ApiProvider>
			<AppProvider>
				<AuthWrapper>
					<RoomProvider>
						<main>
							<Outlet />
						</main>
						<Footer />
					</RoomProvider>
				</AuthWrapper>
			</AppProvider>
		</ApiProvider>
	);
}
function DemoLayout() {
	useScrollToTop();
	return (
		<ApiProvider>
			<DemoAuthProvider>
				<RoomProvider>
					<main>
						<Outlet />
					</main>
					<Footer />
				</RoomProvider>
			</DemoAuthProvider>
		</ApiProvider>
	);
}
export default function App() {

	return (
		<>
			<Suspense fallback={<div>Loading...</div>}>
				<BrowserRouter>
					<Routes>
						{/* /trivia SENZA sessionId -> Home fuori dai provider */}
						<Route element={<PublicLayout />}>
							<Route path="/trivia" element={<Home />} />
						</Route>

						{/* /trivia/demo -> Demo */}
						<Route element={<DemoLayout />}>
							<Route path="/trivia/demo" element={<Demo />} />
						</Route>

						{/* /trivia/quick-match -> partita immediata */}
						<Route element={<PublicLayout />}>
							<Route path="/trivia/quick-match" element={<QuickMatch />} />
						</Route>

						{/* /trivia/:sessionId -> Game dentro i provider */}
						<Route element={<FullLayout />}>
							<Route path="/trivia/:sessionId" element={<Game />} />
						</Route>

						{/* opzionale: fallback 404 pubblico */}
						{/*<Route element={<PublicLayout />}>*/}
						{/*	<Route path="*" element={<NotFound />} />*/}
						{/*</Route>*/}
					</Routes>
				</BrowserRouter>
			</Suspense>
			
		</>
	);
}


